const { AUTH0_DOMAIN: domain, AUTH0_CLIENT_ID: clientId, AUTH0_AUDIENCE: audience } = process.env;

const authConfig =  {
  domain,
  clientId,
  audience,
}
export default authConfig



//////////////////
// WEBPACK FOOTER
// ./config/auth0Config.js
// module id = null
// module chunks = 